import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../i18n/translations';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { LogIn, Info } from 'lucide-react';

export default function Prijava() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    const res = await login(email, password);
    if (!res.ok) {
      toast.error(res.error);
      return;
    }
    toast.success(`Dobrodošli, ${res.user.name}!`);
    navigate(res.user.role === 'turista' ? '/' : '/admin');
  };

  return (
    <div className="bg-[#f8f9fd] min-h-screen py-16">
      <div className="max-w-md mx-auto px-4">
        <div className="bg-white rounded-xl border border-slate-100 p-8 shadow-sm" data-testid="login-card">
          <div className="text-center mb-8">
            <img src="/logo-mp.png" alt="Ministarstvo privrede" className="h-14 w-auto mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-[#0b1a3d]">{t('login')}</h1>
            <p className="text-sm text-slate-500 mt-1">IS E-Turizam – Srednjobosanski kanton</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-600 mb-1.5 block">{t('email')}</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="border-slate-200" />
            </div>
            <div>
              <Label className="text-slate-600 mb-1.5 block">{t('password')}</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="border-slate-200" />
            </div>
            <Button type="submit" className="w-full bg-[#001752] hover:bg-[#0a2a7a] text-white rounded-md h-11 transition-colors duration-200" data-testid="login-submit">
              <LogIn className="h-4 w-4 mr-2" /> {t('login')}
            </Button>
          </form>
          <p className="text-sm text-slate-500 text-center mt-6">
            Nemate račun?{' '}
            <Link to="/registracija" className="text-[#001752] font-semibold hover:underline" data-testid="login-to-register">{t('register')}</Link>
          </p>
        </div>

        <div className="bg-[#e8ecf7] rounded-xl p-5 mt-6 text-sm text-slate-600" data-testid="demo-accounts">
          <p className="flex items-center gap-2 font-semibold text-[#001752] mb-2"><Info className="h-4 w-4" /> Demo računi za testiranje:</p>
          <ul className="space-y-1 text-xs leading-relaxed">
            <li><b>Super admin:</b> admin@eturizam.ba / admin123</li>
            <li><b>Ministarstvo:</b> ministarstvo@eturizam.ba / demo123</li>
            <li><b>Turistička zajednica:</b> tz@eturizam.ba / demo123</li>
            <li><b>MUP:</b> mup@eturizam.ba / demo123</li>
            <li><b>Službenik općine:</b> opcina@eturizam.ba / demo123</li>
            <li><b>Subjekat:</b> subjekat@eturizam.ba / demo123</li>
            <li><b>Turista:</b> turista@eturizam.ba / demo123</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
